import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { STATUS_KEYS } from 'scaleflow/models/initiative-update';

export default class InitiativesProgressPanelProgressFormIndexComponent extends Component {
  status_keys = STATUS_KEYS;

  @service store;
  @service currentUser;
  @tracked progress = this.store.createRecord('initiative-update');

  get initiative() {
    if (!this.args.initiative)
      assert('An initiative needs to be passed to the progress form', false);
    return this.args?.initiative;
  }

  get isDisabled() {
    return !this.progress.status;
  }

  @action
  submitUpdate(e) {
    e.preventDefault();
    this.progress.initiative_id = this.initiative.id;
    this.progress.created_at = new Date().toISOString();
    this.progress.updated_by = { type: 'PERSON', id: this.currentUser.id };
    this.progress.initiative = this.initiative;
    this.progress.save().then(() => {
      this.progress = this.store.createRecord('initiative-update');
      this?.args?.afterSave?.();
    });
  }

  @action
  setProgressStatus(status) {
    this.progress.status = status;
  }

  @action
  setProgressComments(e) {
    this.progress.text_delta = e;
  }

  @action
  setReportedHealth(val) {
    this.progress.reported_health = val;
  }

  @action
  cancelProgressUpdate() {
    this.progress?.deleteRecord?.();
    this.args?.onCancel?.();
  }
}
